<template>
    <div>
        <img ref="oleg" src="/img/oleg.webp" class="fixed transition-all duration-300 top-full left-1/2 z-500 w-40">
        <div ref="sausage" class="swing fixed -top-40 transition-all duration-300 left-1/3 z-500 ">
            <img src="/img/sausage.png" class="w-24">
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        setTimeout(() => {
            this.$refs.oleg.classList.add('-translate-y-1/2');
            setTimeout(() => {
                this.$refs.oleg.classList.remove('-translate-y-1/2');
            }, 1000);
        }, 1000 * this.generateRandom(10, 90));

        setTimeout(() => {
            this.$refs.sausage.classList.add('opened');
            setTimeout(() => {
                this.$refs.sausage.classList.remove('opened');
            }, 2000);
        }, 1000 * this.generateRandom(5, 40));
    },
    methods: {
        generateRandom(min = 0, max = 100) {
            let difference = max - min;
            let rand = Math.random();
            rand = Math.floor(rand * difference);
            rand = rand + min;
            return rand;
        }
    }
}
</script>
<style scoped>
.swing {
    animation: swing ease-in-out 1s infinite alternate;
    transform-origin: center -20px;
}

.swing.opened {
    top: -20px !important;
}

@keyframes swing {
    0% {
        transform: rotate(3deg);
    }
    100% {
        transform: rotate(-3deg);
    }
}
</style>